<script>
import moment from 'moment-timezone';
moment.tz.setDefault('Europe/Paris');
moment.locale('fr');
import axios from "axios";
import {serverErrorsToLocalErrors} from "@/helpers/validations";

export default {
	name: 'modal-invite-admin',
	props: {
		organization: Object,
		onTerminated: Function
	},

	data () {
		return {
			email: "",
			firstname: "",
			lastname: "",
			language: "en",
			error: null,
		}
	},

	computed: {
		buttons() {
			return [
				{
					label: "Send invitation",
					action: this.sendInvitation
				}
			];
		},

		languageOptions() {
			return [
				{value: "en", label: "English"},
				{value: "fr", label: "French"},
			];
		}
	},

	methods: {
		async sendInvitation() {
			this.error = null;
			try {
				const response = await axios.post(process.env.VUE_APP_API_BASE_URL + "/backoffice/invite-admin", {
					organizationId: this.organization._id,
					email: this.email,
					firstname: this.firstname,
					lastname: this.lastname,
					language: this.language
				}, {
					headers: {
						'X-User-Token': localStorage.getItem("BACKOFFICE_TOKEN")
					}
				});
				if (this.onTerminated) {
					this.onTerminated(response.data._id);
				}
				this.$refs.modal.close();
			}
			catch(err) {
				this.error = serverErrorsToLocalErrors(err.response.data);
				console.error("Error sending invitation: ", this.error);
			}
		},

		canceled() {
			if(this.onTerminated) {
				this.onTerminated(null);
			}
		},

		translateErrors(field, id) {
			switch(field) {
				case "firstname":
					switch(id) {
						case "emptyString":
							return "Firstname is required";
						default:
							return id;
					}
				case "lastname":
					switch(id) {
						case "emptyString":
							return "Lastname is required";
						default:
							return id;
					}
				case "email":
					switch(id) {
						case "nullValue":
							return "Email is required";
						case "badFormat":
							return "Email is not valid";
						default:
							return id;
					}
				case "global":
					switch(id) {
						case "organization_notfound":
							return "A configuration error occurs. Try to refresh the page in your navigator.";
						case "existingUser":
							return "A user with this email already exists in the users database.";
						default:
							return id;
					}
			}
		}
	}
}
</script>

<template>
	<modal ref="modal" class="ModalInviteAdmin" title="Invite a new admin to this organization" :buttons="buttons" @cancel="canceled">
		<div class="invite-form">
			<div class="field">
				<label>Firstname</label>
				<field-input propertyName="firstname" v-model="firstname"/>
				<div v-if="error?.firstname" class="error" v-html="translateErrors('firstname', error.firstname.id)"/>
			</div>
			<div class="field">
				<label>Lastname</label>
				<field-input propertyName="lastname" v-model="lastname"/>
				<div v-if="error?.lastname" class="error" v-html="translateErrors('lastname', error.lastname.id)"/>
			</div>
			<div class="field">
				<label>Email</label>
				<field-input propertyName="email" v-model="email"/>
				<div v-if="error?.email" class="error" v-html="translateErrors('email', error.email.id)"/>
			</div>
			<div class="field">
				<label>Language</label>
				<field-select propertyName="language" v-model="language" :options="{options: languageOptions}"/>
				<div v-if="error?.email" class="error" v-html="translateErrors('language', error.language.id)"/>
			</div>
		</div>
		<div v-if="error?._global" class="error" v-html="translateErrors('global', error._global.id)"/>
	</modal>
</template>

<style lang="scss">
@import "../../node_modules/@snark/backoffice/src/sass/variables.scss";

.ModalInviteAdmin {
	.modal-container {
		width: 600px;
	}

	.error {
		margin: 10px 0;
		color: #e33232;
	}

	.invite-form {
		display: flex;
		flex-direction: column;
		gap: 10px;
		label {
			color: $title2Color;
			margin-bottom: 5px;
		}
	}
}
</style>
